/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaModalHeader/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaModalHeader({
  children,
  viewPath = "/DesignSystem/TysiaModal/TysiaModalHeader",
  justifyContent = "space-between",
  onClose
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaModalHeader.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-2vtzS1': dtColorsWhite,'--pl-2-2vtzS1': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-2vtzS1': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-4-2vtzS1': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-5-2vtzS1': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--jc-6-2vtzS1': justifyContent,'--bbc-7-2vtzS1': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 onClose={onClose}
>
{children}
</Children>
</div>
</React.Fragment>)
}